// // CelebrantCard.jsx
// import React from "react";

// const CelebrantCard = ({ name, role, date, imageUrl }) => {
//   console.log("imageUrl received by Card:", imageUrl);

//   return (
//     <div className="bg-[#f5f6fc] font-Outfit p-4 rounded-md w-[227px] h-[277px] shadow-md text-center">
//       <div className="flex justify-center mb-4">
//         <div className="w-[100px] h-[100px] rounded-full overflow-hidden border-2 border-blue-500">
//           <img
//             src={imageUrl}
//             alt={name}
//             className="w-full h-full object-cover"
//           />
//           🎉
//         </div>
//       </div>
//       <h3 className="font-semibold mt-4">{name}</h3>
//       <p className="text-sm">{role}</p>
//       <p className="text-xs mt-1">{date}</p>
//     </div>
//   );
// };

// export default CelebrantCard;

import React from "react";

const CelebrantCard = ({ name, role, date, imageUrl, isToday }) => {
  return (
    <div
      className={`font-Outfit p-4 rounded-md w-[227px] h-[277px] shadow-md text-center 
      ${
        isToday
          ? "bg-gradient-to-b from-[#5608D4] to-[#384295] text-white border border-blue-500"
          : "bg-[#1234CD0D]"
      }`}
    >
      <div className="flex justify-center mb-4">
        <div className="w-[120px] h-[120px  ] rounded-full overflow-hidden border-2 border-blue-500">
          <img
            src={imageUrl}
            alt={name}
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      <h3 className="font-semibold mt-4">{name}</h3>
      <p className="text-sm">{role}</p>
      <p className="text-xs mt-1">{date}</p>
    </div>
  );
};

export default CelebrantCard;
